import { styled } from "@mui/material/styles";
import { ForwardedRef, forwardRef } from "react";
import { Link as RRLink, LinkProps } from "react-router-dom";

const Link = styled(RRLink)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.primary.main,
  "&:hover": {
    textDecoration: "underline",
  },
}));

export default forwardRef(function CustomLink(props: LinkProps, ref: ForwardedRef<HTMLAnchorElement>) {
  const { to, children, className, ...rest } = props;

  return (
    <Link to={to} className={className} ref={ref} {...rest}>
      {children}
    </Link>
  );
});
